<template>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3>Preencher Avaliação da Voluntária</h3>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuarioLogado.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
          <b-card-body>
          <b-form v-on:submit.prevent="onSubmit">
            <b-row>
              <b-col cols="10">
                <b-form-group label="Voluntária: *">
                  <b-input-group>
                    <b-form-select v-model="$v.form.voluntaria.$model" :state="chkState('voluntaria')">
                      <option v-for="item in listavoluntarias" :key="item.voluntario_id" :value="item.voluntario_id"> {{item.nome}}</option>
                      <option selected :value="null"> Selecione</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback6">Voluntária é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col @click="openModal" id="modal" md="4" offset-md="7">Exibir voluntárias já avaliadas</b-col>
            </b-row>
               <b-row>
                  <b-col md="9">
                    <p>Estrelinhas: *</p>
                      <star-rating
                      :state="chkState('estrelas')"
                        v-model="$v.form.estrelas.$model"
                        :border-width="3"
                        v-bind:increment="1"
                        v-bind:star-size="30"
                        v-bind:max-rating="5"/>
                         <b-form-invalid-feedback :state="chkState('estrelas')" id="input1LiveFeedback6">Estrelas são obrigatórias.</b-form-invalid-feedback>
                  </b-col>
               </b-row>
                <b-row>
                  <b-col md="10">
                        <br>
                        <p>Observação: <i>(Opcional)</i></p>
                        <b-form-textarea id="textarea" v-model="$v.form.comentario.$model" rows="3" max-rows="6"></b-form-textarea>
                  </b-col>
               </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
       <b-row>
            <b-col md="3" offset-md="3">
              <b-button block variant="primary" v-on:click="onSubmit">
                <i class="fa fa-check"></i>&nbsp;
                <span>Salvar </span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
        <b-modal title="Voluntárias já Avaliadas" :hide-footer="true" hide-header-close v-model="modal">
            <b-card-body>
                 <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="10" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-md table-bordered table-striped table-md">
                          <tbody v-if="listaJaAvaliadas.length">
                            <tr v-for="item in listaJaAvaliadas" :key="item.id">
                              <td @click="SelecionaVoluntaria(item)">{{item.nome}}</td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="5">Nenhuma voluntária encontrada...</td>
                           </tr>
                          </tbody>
                         </table>
                       </span>
                </b-container>
                 </b-col>
           </b-card-body>
           <b-card-footer class="p-12">
                <b-button variant="secondary" @click="fecharModal"><i class="fa fa-times">&nbsp;</i> Cancelar</b-button>
           </b-card-footer>
        </b-modal>
      </b-card>
</template>

<script>
import Vue from 'vue'
import StarRating from 'vue-star-rating'
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/Pagination'
import miniToastr from 'mini-toastr'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

miniToastr.init()

const formShape = {
  voluntaria: null,
  estrelas: null,
  comentario: ''
}

export default {
  components: {
    StarRating,
    VueSelect,
    Pagination
  },
  mixins: [validationMixin],
  validations: {
    form: {
      voluntaria: {
        required
      },
      estrelas: {
        required
      },
      comentario: {
        // required
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'B' ||
    SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('buscarEstados')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.$store.dispatch('getVoluntario')
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.getVoluntaias()
    } else {
      this.$router.push('/')
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadPrograma(this.$route.params.id)
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      listaJaAvaliadas: [],
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      rating: 'No Rating Selected',
      currentRating: 'No Rating',
      currentSelectedRating: 'No Current Rating',
      modal: false,
      boundRating: 3
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    meuVoluntario () {
      return this.$store.state.usuario.meuVoluntarioAtendimento
    },
    motivosRemocao () {
      return this.$store.state.atendimento.motivosRemocaoBeneficiaria
    },
    justificativas () {
      return this.$store.state.atendimento.justificativas
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    listavoluntarias () {
      return this.$store.state.usuario.ListaVoluntario
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach(element => {
        if (element.municipio_id === this.usuario.dados_pessoais.municipio_atuacao_id) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  methods: {
    formatDate (criadoEm) {
      let date = new Date(criadoEm)

      let day = date.getDate()
      let month = (date.getMonth() + 1)

      if (month < 10) {
        month = '0' + month
      }

      if (day < 9) {
        day = '0' + (day + 1)
      } else {
        day = day + 1
      }

      return day + '/' + month + '/' + date.getFullYear()
    },
    SelecionaVoluntaria (item) {
      this.$v.form.voluntaria.$model = null
      this.listavoluntarias.map(element => {
        if (Number(element.voluntario_id) === Number(item.id)) { this.$v.form.voluntaria.$model = item.id }
      })
      if (this.$v.form.voluntaria.$model) {
        this.modal = false
      } else {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Voluntária selecionada não está mais atuando em seu município!!', 'Ops!', 5000)
      }
    },
    fecharModal () {
      this.modal = false
    },
    openModal () {
      this.modal = true
    },
    getVoluntaias () {
      Vue.http.get('api/avaliacoes-voluntarias').then(response => {
        this.listaJaAvaliadas = response.body.data[0]
      })
    },
    loadPrograma (id) {
      Vue.http.get('api/avaliacoes/' + id).then(response => {
        this.form.voluntaria = response.body.data[0].voluntaria_id
        this.form.estrelas = response.body.data[0].estrelas
        this.form.comentario = response.body.data[0].comentario
        this.id = response.body.data[0].id
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        voluntaria_id: form.voluntaria.$model,
        comentario: form.comentario.$model,
        estrelas: form.estrelas.$model
      }

      this.loadingCancelar = true
      Vue.http.post('api/avaliacoes', data).then(response => {
        miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
        miniToastr.success('Avaliação salva com sucesso!', 'Sucesso!', 7000)
        this.$router.push('/avaliar-voluntarias')
      }).catch(e => {
        let response = e.body
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error(response.msg, 'Ops!', 9000)
      })
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
    #modal {
      font-style: italic;
      font-weight: bold;
      margin-top: -10px;
      cursor: pointer;
    }

    td {
      font-weight: bold;
      text-align: center;
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/beneficiaria/AvaliarEncontroForm.vue